module.exports = __webpack_public_path__ + "trust-marks-inc.7e2a26.png";